import * as tslib_1 from "tslib";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { endOfDay, mapIds, mapStringToArrayOfIds, startOfDay } from '@core/utils/filters-utils';
import { DateIntervalValidation } from '@validators/date-interval-validation';
import { DateValidation } from '@validators/date.validation';
import { isEqual } from 'lodash';
import moment from 'moment';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ReportsService } from '../../reports.service';
import * as i0 from "@angular/core";
import * as i1 from "../../reports.service";
import * as i2 from "@angular/router";
var FilterService = /** @class */ (function () {
    function FilterService(reportsService, route, router) {
        var _this = this;
        this.reportsService = reportsService;
        this.route = route;
        this.router = router;
        this.routePage = 'relatorios/formularios';
        this.removeSubscriptions = new Subject();
        this.defaultFilterValue = {
            initialDate: moment().subtract(1, 'month'),
            finalDate: moment(),
            locations: null,
            maintenanceTypes: null,
            segments: null,
            companies: null,
            locationGroups: null,
            formContent: ''
        };
        this.isFilterOn = false;
        this.isFilterExpanded = false;
        this.filterForm = new FormGroup({
            initialDate: new FormControl(this.defaultFilterValue.initialDate, [Validators.required, DateValidation.validate]),
            finalDate: new FormControl(this.defaultFilterValue.finalDate, [Validators.required, DateValidation.validate]),
            locations: new FormControl(this.defaultFilterValue.locations),
            maintenanceTypes: new FormControl(this.defaultFilterValue.maintenanceTypes),
            segments: new FormControl(this.defaultFilterValue.segments),
            companies: new FormControl(this.defaultFilterValue.companies),
            locationGroups: new FormControl(this.defaultFilterValue.locationGroups),
            formContent: new FormControl(this.defaultFilterValue.formContent)
        }, {
            validators: [
                DateIntervalValidation.validate({
                    from: 'initialDate',
                    to: 'finalDate',
                    maxDiffLte: 1,
                    unit: 'year'
                })
            ]
        });
        this.reportsService.preserveSavedFilterValues('forms-dashboard-filter', this.filterForm, this.defaultFilterValue);
        this.filterForm.valueChanges.pipe(takeUntil(this.removeSubscriptions), filter(function () { return _this.filterForm.valid; })).subscribe(function () {
            _this.isFilterOn = !isEqual({
                initialDate: moment(_this.filterForm.value.initialDate).format('LL'),
                finalDate: moment(_this.filterForm.value).format('LL'),
                locations: _this.filterForm.value.locations,
                maintenanceTypes: _this.filterForm.value.maintenanceTypes,
                segments: _this.filterForm.value.segments,
                companies: _this.filterForm.value.companies,
                locationGroups: _this.filterForm.value.locationGroups,
                formContent: _this.filterForm.value.formContent
            }, {
                initialDate: moment(_this.defaultFilterValue.initialDate).format('LL'),
                finalDate: moment(_this.defaultFilterValue.finalDate).format('LL'),
                locations: _this.defaultFilterValue.locations,
                maintenanceTypes: _this.defaultFilterValue.maintenanceTypes,
                segments: _this.defaultFilterValue.segments,
                companies: _this.defaultFilterValue.companies,
                locationGroups: _this.defaultFilterValue.locationGroups,
                formContent: _this.defaultFilterValue.formContent
            });
            if (_this.isFilterOn) {
                var where = _this.toDetailQuery();
                _this.setUrlAfterFilter(where);
            }
        });
    }
    Object.defineProperty(FilterService.prototype, "valueChanges", {
        get: function () {
            return this.filterForm.valueChanges;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterService.prototype, "value", {
        get: function () {
            return this.filterForm.value;
        },
        enumerable: true,
        configurable: true
    });
    FilterService.prototype.reload = function () {
        this.filterForm.updateValueAndValidity();
    };
    FilterService.prototype.toggleExpanded = function () {
        this.isFilterExpanded = !this.isFilterExpanded;
    };
    FilterService.prototype.clearFilters = function () {
        var queryParams = this.route.snapshot.queryParams;
        var origin = location.origin + location.pathname;
        if (queryParams.formId_eq) {
            origin = origin.concat("#/" + this.routePage + "/detalhes?formId_eq=", queryParams.formId_eq);
        }
        else {
            origin = origin.concat("#/" + this.routePage);
        }
        localStorage.removeItem('forms-dashboard-filter');
        window.history.pushState({}, null, origin);
        this.filterForm.patchValue(this.defaultFilterValue);
    };
    FilterService.prototype.toQuery = function (value) {
        return {
            locationId_in: mapIds(value.locations),
            segmentId_in: mapIds(value.segments),
            companyId_in: mapIds(value.companies),
            createdAt_lte: endOfDay(value.finalDate),
            createdAt_gte: startOfDay(value.initialDate),
            locationGroupId_in: mapIds(value.locationGroups),
            maintenanceTypeId_in: mapIds(value.maintenanceTypes),
            formAnswer_contains: value.formContent
        };
    };
    FilterService.prototype.toDetailQuery = function () {
        return {
            formId_eq: this.route.snapshot.queryParams.formId_eq,
            locationId_in: mapIds(this.value.locations),
            segmentId_in: mapIds(this.value.segments),
            companyId_in: mapIds(this.value.companies),
            createdAt_lte: endOfDay(this.value.finalDate),
            createdAt_gte: startOfDay(this.value.initialDate),
            locationGroupId_in: mapIds(this.value.locationGroups),
            maintenanceTypeId_in: mapIds(this.value.maintenanceTypes),
            formAnswer_contains: this.value.formContent
        };
    };
    FilterService.prototype.setUrlAfterFilter = function (where) {
        var isOnTheDetailsPage = this.router.url.includes('detalhes');
        var routePage = "" + this.routePage + (isOnTheDetailsPage ? '/detalhes' : '');
        var queryParams = this.reportsService.keepOnlyChangedValuesOnQueryParams(where, tslib_1.__assign({ formId_eq: null }, this.toQuery(this.defaultFilterValue)));
        var urlTree = this.router.createUrlTree([routePage], { queryParams: queryParams });
        var url = this.router.serializeUrl(urlTree);
        var pathName = "" + location.origin + location.pathname + "#" + url;
        window.history.pushState({}, null, pathName);
    };
    FilterService.prototype.setFilterFromQueryParams = function () {
        var queryParams = this.route.snapshot.queryParams;
        if (isEqual(queryParams, {})) {
            return;
        }
        var filterValue = {
            initialDate: queryParams.createdAt_gte ? moment(moment.utc(queryParams.createdAt_gte).format('YYYY-MM-DD')) : this.defaultFilterValue.initialDate,
            finalDate: queryParams.createdAt_lte ? moment(moment.utc(queryParams.createdAt_lte).format('YYYY-MM-DD')) : this.defaultFilterValue.finalDate,
            locations: queryParams.locationId_in ? mapStringToArrayOfIds(queryParams.locationId_in) : this.defaultFilterValue.locations,
            maintenanceTypes: queryParams.maintenanceTypeId_in ? mapStringToArrayOfIds(queryParams.maintenanceTypeId_in) : this.defaultFilterValue.maintenanceTypes,
            segments: queryParams.segmentId_in ? mapStringToArrayOfIds(queryParams.segmentId_in) : this.defaultFilterValue.segments,
            companies: queryParams.companyId_in ? mapStringToArrayOfIds(queryParams.companyId_in) : this.defaultFilterValue.companies,
            locationGroups: queryParams.locationGroupId_in ? mapStringToArrayOfIds(queryParams.locationGroupId_in) : this.defaultFilterValue.locationGroups,
            formContent: queryParams.formAnswer_contains || this.defaultFilterValue.formContent
        };
        this.filterForm.setValue(filterValue);
        this.filterForm.updateValueAndValidity();
        this.isFilterOn = true;
    };
    FilterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FilterService_Factory() { return new FilterService(i0.ɵɵinject(i1.ReportsService), i0.ɵɵinject(i2.ActivatedRoute), i0.ɵɵinject(i2.Router)); }, token: FilterService, providedIn: "root" });
    return FilterService;
}());
export { FilterService };
